import { render, staticRenderFns } from "./StudentsView.vue?vue&type=template&id=fefc6cd6&"
import script from "./StudentsView.vue?vue&type=script&lang=js&"
export * from "./StudentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports